import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AinStateComponent } from '../design-system/state.component';
import { LocalizationService } from '../../core/localization/localization.service';
import { ModuleSurfaceConfiguration } from './workflow-task-context';

@Component({
  standalone: true,
  selector: 'ain-workflow-surface-fallback',
  imports: [AinStateComponent, ButtonModule, RouterLink],
  template: `
    <ain-state
      type="error"
      [title]="title"
      [message]="message" />
    <div class="actions">
      <a routerLink="/workflow/tasks">{{ t('workflow.taskHost.backToInbox') }}</a>
      @if (showEscape && escapeRoute) {
        <button
          pButton
          type="button"
          severity="secondary"
          [label]="t('workflow.taskHost.openInModule')"
          (click)="navigateEscape()"></button>
      }
    </div>
  `,
  styles: [`
    .actions { display: flex; gap: 12px; align-items: center; margin-top: 12px; flex-wrap: wrap; }
    a { color: var(--ain-color-primary); font-weight: 600; text-decoration: none; }
  `]
})
export class WorkflowSurfaceFallbackComponent {
  private readonly localization = inject(LocalizationService);

  @Input({ required: true }) title = '';
  @Input({ required: true }) message = '';
  @Input() surfaceConfiguration?: ModuleSurfaceConfiguration;
  @Input() showEscape = false;

  get escapeRoute(): string | null {
    const route = this.surfaceConfiguration?.fullPageRouteTemplate?.trim();
    return route || null;
  }

  navigateEscape(): void {
    const route = this.escapeRoute;
    if (!route) {
      return;
    }

    window.location.assign(route);
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
